<template>
	<article>
		<PushController />
	</article>
</template>

<script>
	import PushController from '@/components/manage/PushController.vue';

	export default {
		name: 'PushSend',
		components: { PushController },
		created() {
			this.$store.commit('PushController/init');
			if (localStorage.idList) {
				const idList = localStorage.idList.split(',');
				localStorage.removeItem('idList');
				this.$store.dispatch('PushController/initRegisterList', idList);
			}
		},
	};
</script>
